import { useQuery } from "@apollo/client"
import { GET_TOURNAMENT_LIST, GET_TOURNAMENT_LIST_RESUMED } from "../queries/tournamentList"
import { Tournament } from "../types"
import { Input } from "@/components/ui/input"

interface TournamentListInput {
  gameId: number
  seasonId?: number
  page?: number
  limit?: number
  formatId?: number
  typeId?: number
  storeId?: number
  countryId?: number
  regionId?: number
  isActiveSeason?: number
  isPresential?: number
  search?: string
  date?: string
  players?: number[]
  statusId?: number[]
}

interface TournamentListParams {
  input: TournamentListInput
}

export const useTournamentList = (params: TournamentListParams) => {
  const { data, loading, error, refetch } = useQuery<{
    TournamentListV2: {
      status: {
        success: boolean
        name: string
        detail: string
      }
      Tournaments: Tournament[]
      hasNextPage?: boolean
    }
  }>(GET_TOURNAMENT_LIST, {
    variables: {
      TournamentListInputV2: {
        ...params.input,
        isActiveSeason: 2,
      },
    },
    errorPolicy: "all",
  })

  return {
    tournaments: data?.TournamentListV2?.Tournaments || [],
    hasNextPage: data?.TournamentListV2?.hasNextPage || false,
    status: data?.TournamentListV2?.status,
    loading,
    error,
    refetch,
  }
}

export const useTournamentListHeader = (params: TournamentListParams, isAuthenticated = false) => {
  const { data, loading, error, refetch } = useQuery<{
    TournamentListV2: {
      status: {
        success: boolean
        name: string
        detail: string
      }
      Tournaments: Tournament[]
      pages?: number
      total?: number
    }
  }>(GET_TOURNAMENT_LIST_RESUMED, {
    variables: {
      TournamentListInputV2: {
        ...params.input,
        isActiveSeason: 2,
      },
    },
    errorPolicy: "all",
    skip: !isAuthenticated || !params.input.players.filter((x) => x).length,
  })

  return {
    tournaments: data?.TournamentListV2?.Tournaments || [],
    status: data?.TournamentListV2?.status,
    loading,
    error,
    refetch,
  }
}
